import React, { useState } from 'react';

const Slider = ({ setZoom }) => {
  const [distance, setDistance] = useState(4);

  const handleDistanceChange = (e) => {
    setDistance(Number(e.target.value));
    setZoom(13 - Number(e.target.value - e.target.value * 0.5));
  };

  return (
    <div className="w-64 bg-gray-100 p-3  ml-8">
      <div className="flex items-center mb-4">
        <div className="text-base font-normal text-gray-800 mr-4">Distance:</div>
        <div className="text-base font-normal text-gray-800 ml-20">{distance} km</div>
      </div>
      <div className="relative">
        <input
          type="range"
          min={1}
          max={5}
          value={distance}
          onChange={handleDistanceChange}
          className="text-green-500 absolute top-1/2 left-0 w-full h-1 -translate-y-1/2 thumb:z-20 thumb:w-8 thumb:h-8 thumb:bg-green-500 thumb:rounded-full thumb:shadow-lg thumb:outline-none"
          style={{ background: 'transparent' }}
        />
        <div
          className="absolute top-1/2 left-0 w-full h-1 -translate-y-1/2 bg-green-500 rounded-full"
          style={{ width: `${(distance )*3.3}vw` }}
        ></div>
      </div>
    </div>
  );
};

export default Slider;
